// Mock data for All Heaven Interior website

export const businessInfo = {
  name: "All Heaven Interior",
  owner: "Sanjeev Bansal",
  tagline: "Premium Interior Designing & Window Solutions in Delhi",
  phones: ["+91 9810812274", "+91 9354009744"],
  email: "sanjeevbansal1970@gmail.com",
  address: "A-18, Jagat Puri, Near SBI Bank, Jagat Puri Red Light, Delhi-110051",
  instagram: "https://www.instagram.com/all.heaven.interior/",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.5234!2d77.2999!3d28.6392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDM4JzIxLjEiTiA3N8KwMTcnNTkuNiJF!5e0!3m2!1sen!2sin!4v1234567890"
};

export const services = [
  {
    id: 1,
    title: "Complete Interior Designing",
    description: "Transform your residential and commercial spaces with our expert interior design solutions. From concept to completion.",
    icon: "Home"
  },
  {
    id: 2,
    title: "Window Blinds",
    description: "Authorized Vista Fashion dealer offering premium quality window blinds in various styles, colors, and materials.",
    icon: "Blinds"
  },
  {
    id: 3,
    title: "Curtains & Curtain Rods",
    description: "Elegant curtains and designer curtain rods to complement your interior décor perfectly.",
    icon: "Pilcrow"
  },
  {
    id: 4,
    title: "Wooden Flooring",
    description: "High-quality wooden flooring solutions that add warmth and elegance to your spaces.",
    icon: "Square"
  },
  {
    id: 5,
    title: "Wallpapers",
    description: "Extensive collection of designer wallpapers to give your walls a stunning makeover.",
    icon: "Frame"
  }
];

export const products = [
  {
    id: 1,
    category: "Window Blinds",
    name: "Roller Blinds",
    description: "Modern roller blinds with light control and privacy features",
    image: "https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?w=600&q=80"
  },
  {
    id: 2,
    category: "Window Blinds",
    name: "Vertical Blinds",
    description: "Perfect for large windows and sliding doors",
    image: "https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5?w=600&q=80"
  },
  {
    id: 3,
    category: "Window Blinds",
    name: "Venetian Blinds",
    description: "Classic horizontal blinds for precise light control",
    image: "https://images.unsplash.com/photo-1616137466211-f939a420be84?w=600&q=80"
  },
  {
    id: 4,
    category: "Curtains",
    name: "Designer Curtains",
    description: "Luxury fabric curtains in various patterns and colors",
    image: "https://images.unsplash.com/photo-1557128928-66e3009291b5?w=600&q=80"
  },
  {
    id: 5,
    category: "Curtains",
    name: "Sheer Curtains",
    description: "Light and elegant sheer curtains for soft natural light",
    image: "https://images.unsplash.com/photo-1600494448655-7b8ad96e8f8e?w=600&q=80"
  },
  {
    id: 6,
    category: "Wallpapers",
    name: "3D Wallpapers",
    description: "Contemporary 3D textured wallpapers for feature walls",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&q=80"
  },
  {
    id: 7,
    category: "Wallpapers",
    name: "Luxury Wallpapers",
    description: "Premium designer wallpapers with unique patterns",
    image: "https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=600&q=80"
  },
  {
    id: 8,
    category: "Wooden Flooring",
    name: "Laminate Flooring",
    description: "Durable and affordable wooden laminate flooring",
    image: "https://images.unsplash.com/photo-1534237710431-e2fc698436d0?w=600&q=80"
  }
];

export const projects = [
  {
    id: 1,
    title: "Modern Living Room",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80",
    description: "Contemporary living space with custom furniture and blinds"
  },
  {
    id: 2,
    title: "Luxury Bedroom",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=800&q=80",
    description: "Elegant bedroom design with premium curtains and wallpaper"
  },
  {
    id: 3,
    title: "Office Interior",
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&q=80",
    description: "Professional office space with modern blinds and flooring"
  },
  {
    id: 4,
    title: "Modular Kitchen",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&q=80",
    description: "Contemporary kitchen with smart storage solutions"
  },
  {
    id: 5,
    title: "Dining Area",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1617806118233-18e1de247200?w=800&q=80",
    description: "Sophisticated dining space with designer lighting"
  },
  {
    id: 6,
    title: "Retail Showroom",
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80",
    description: "Modern retail interior with custom displays"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    location: "East Delhi",
    rating: 5,
    text: "Excellent work! The team transformed our home beautifully. Very professional and timely service."
  },
  {
    id: 2,
    name: "Priya Sharma",
    location: "Preet Vihar",
    rating: 5,
    text: "Best interior designer in Delhi! The Vista Fashion blinds are of premium quality. Highly recommended."
  },
  {
    id: 3,
    name: "Amit Verma",
    location: "Mayur Vihar",
    rating: 5,
    text: "Amazing experience from consultation to installation. Sanjeev ji is very knowledgeable and helpful."
  }
];

export const vistaFashionProducts = [
  {
    id: 1,
    name: "Premium Roller Blinds",
    features: ["100% Blackout Option", "Easy Installation", "5 Year Warranty", "Motorized Available"],
    image: "https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?w=600&q=80"
  },
  {
    id: 2,
    name: "Vertical Blinds",
    features: ["Wide Range of Colors", "UV Protection", "Perfect for Large Windows", "Easy Maintenance"],
    image: "https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5?w=600&q=80"
  },
  {
    id: 3,
    name: "Venetian Blinds",
    features: ["Aluminum/Wood Options", "Precise Light Control", "Durable", "Stylish Design"],
    image: "https://images.unsplash.com/photo-1616137466211-f939a420be84?w=600&q=80"
  },
  {
    id: 4,
    name: "Zebra Blinds",
    features: ["Day & Night Option", "Modern Look", "Privacy Control", "Energy Efficient"],
    image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=600&q=80"
  }
];
